import { useState, useEffect } from "react";
import { useApi } from "../../hooks/use-api";
import {
  API_GET_MEDIUM_OF_INSTRUCTION,
  API_USER_PROFILE_UPDATE,
  apiGetApprovedCourses,
} from "../../utils/api-routes";
import assets from "../../assets";
import { useSingleton } from "../../hooks/use-singleton";
import { COMPETITIVE_EXAM_STATIC_DATA } from "../../utils/constant";
import { ROUTE_DASHBOARD } from "../../route/studentRoute";
import { ROUTE_DASHBOARD as NeetJ2ERoute } from "../../route/neetJteRoute";
import {
  ROUTE_STUDENT_MANAGEMENT,
  ROUTE_DASHBOARD as ROUTE_USER_DASHBOARD,
} from "../../route";
import { useNavigate } from "react-router-dom";
import { ROUTE_DASHBOARD as TnpscRoute } from "../../route/tnpscRoute";
import { ROUTE_DASHBOARD as BankinRoutes } from "../../route/bankingRoute";
import { useNotify } from "../../hooks/use-notify";

const getIcon = (course) => {
  switch (course) {
    case "JEE":
      return assets.ic_jee;
    case "TNPSC":
      return assets.ic_upse; // make sure this exists
    case "RRB":
      return assets.ic_railway; // make sure this exists
    default:
      return assets.ic_jee; // fallback
  }
};

const getDescription = (course) => {
  switch (course) {
    case "JEE":
      return "Engineering entrance exam";
    case "TNPSC":
      return "Tamil Nadu government jobs";
    case "RRB":
      return "Railway recruitment exams";
    default:
      return `${course} exam preparation`;
  }
};

const useHandler = () => {
  const { post, get } = useApi();
  const { toggleNotify } = useNotify();
  const navigate = useNavigate();
  const {
    mail,
    user,
    role,
    medium,
    examType,
    getUserDetails,
    updateRole,
    updateBoard,
    updateExam,
    updateMedium,
    updateUserData,
  } = useSingleton();
  const [preferences, setPreferences] = useState([]);
  const [accessData, setAccessData] = useState({
    classGrade: "",
    medium: "",
  });
  const [showPopup, setShowPopup] = useState(false);
  const [selectedPreference, setSelectedPreference] = useState(null);
  const [getMediums, setGetMediums] = useState([]);
  const SCHOOL_BASED_EXAMS = ["TN_STATE_BOARD", "ICSE", "CAIE", "CBSE"];

  const getApprovedCourses = async () => {
    try {
      const res = await get(apiGetApprovedCourses(mail));

      const approved = res?.data?.approved_courses || [];

      const userClass = user?.data?.class?.toLowerCase();

      const formatted = approved?.map((item) => {
        const courseName = item.exam || item.course || item;
        const staticInfo = COMPETITIVE_EXAM_STATIC_DATA.find(
          (s) => s.title.toUpperCase() === courseName.toString().toUpperCase(),
        );

        return {
          id: courseName.toString().toLowerCase(),
          title: staticInfo?.title || courseName,
          desc: staticInfo?.description || getDescription(courseName),
          icon: staticInfo?.icon || getIcon(courseName),
          // enabled: courseName.toString().toLowerCase() === userClass,
          enabled: item?.is_active,
          disabled: false,
        };
      });

      const filteredCoureses = formatted?.filter(
        (item) => item?.title !== "Communicative English",
      );

      // setPreferences(formatted);
      setPreferences(filteredCoureses);
    } catch (err) {
      console.log("API ERROR:", err);
    }
  };

  useEffect(() => {
    if (!mail || !user?.data?.class) return; // ✅ wait for BOTH

    getApprovedCourses();
  }, [mail, user]);

  const userProfileUpdate = async ({ exam, class_grade, medium }) => {
    const isSchoolCourse = SCHOOL_BASED_EXAMS.includes(exam);
    const payload = {
      email: mail,
      exam_type: exam,
      class_grade: isSchoolCourse ? class_grade : null,
      medium: medium,
    };
    try {
      const res = await post(API_USER_PROFILE_UPDATE, payload);
      if (res) {
        const responseData = res?.data?.data || {};
        const { focus, board, medium, role } = responseData || {};
        updateBoard(board);
        updateMedium(medium);
        updateRole(role);
        updateExam(focus);
        updateUserData(res?.data);

        // ✅ Navigation based on exam_type
        if (
          exam?.startsWith("CBSE") ||
          exam?.startsWith("TN_STATE_BOARD") ||
          exam?.startsWith("ICSE") ||
          exam?.startsWith("CAIE")
        ) {
          navigate(ROUTE_USER_DASHBOARD);
        }
        if (exam?.startsWith("NEET") || exam?.startsWith("JEE")) {
          navigate(NeetJ2ERoute);
        } else if (exam?.startsWith("UPSC")) {
          navigate(ROUTE_DASHBOARD);
        } else if (exam?.startsWith("TNPSC")) {
          navigate(TnpscRoute);
        } else if (board === "Banking" || exam?.startsWith("Banking")) {
          navigate(BankinRoutes);
        }
        // toggleNotify({
        //   type: "success",
        //   title: "Please Click Dasboard Tab",
        // });
      }
    } catch (e) {
      console.log("ERROR COMES FROM USER PROFILE UPDATE API");
    }
  };

  const getMediumOfInstructionsInProfile = async (selectedExam) => {
    try {
      if (!selectedExam?.title) {
        setGetMediums([]);
        return;
      }

      const focus = encodeURIComponent(selectedExam.title);

      const res = await get(`${API_GET_MEDIUM_OF_INSTRUCTION}?focus=${focus}`);

      if (res) {
        setGetMediums(res?.data?.medium_of_instruction || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM API MEDIUM OF INSTRUCTION", e);
    }
  };

  return {
    preferences,
    accessData,
    showPopup,
    selectedPreference,
    getMediums,
    setShowPopup,
    setSelectedPreference,
    setAccessData,
    setPreferences,
    userProfileUpdate,
    getMediumOfInstructionsInProfile,
  };
};

export default useHandler;
